import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSupportContactMessages,
  selectSupportState,
  submitSupportContactFormThunk,
} from "../store/supportSlice";

export const useSupportContactForm = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectSupportState);

  const submitContactForm = useCallback(
    async ({ subject, message }) => {
      const action = await dispatch(
        submitSupportContactFormThunk({
          subject,
          message,
        }),
      );

      return submitSupportContactFormThunk.fulfilled.match(action);
    },
    [dispatch],
  );

  const clearMessages = useCallback(() => {
    dispatch(clearSupportContactMessages());
  }, [dispatch]);

  return {
    isSubmitting: state.isSubmittingContactForm,
    error: state.contactFormError,
    success: state.contactFormSuccess,
    submitContactForm,
    clearMessages,
  };
};

export default useSupportContactForm;
